import { breakpoint } from '@carvana/helios-styles';
import { Button } from '@carvana/helios-navigation';

import { useTestFunc } from '@carvana/test-attributes';
import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import { useMediaQuery } from '../../shared/hooks/useMediaQuery';
import { buildNavigationUrl } from '../../shared/routes';
import ValueTrackerLogo from './ValueTrackerLogo';
import {
  Background,
  Container,
  HeadLine,
  ImgWrapper,
  StyledImage,
  StyledLink,
  Text,
  TextContainer,
  LogoWrapper,
  RedirectLink
} from './Worth.styles';

const customLoader = ({ src }: { src: string }) => {
  const appUrl = process.env.CARVANA_APP_PUBLIC_URL!;
  const prefix = appUrl.includes('localhost') ? appUrl : `${appUrl}/next`;
  return `${prefix}${src}.webp`;
};

type WorthProps = {
  videoExperiment?: boolean;
};

const Worth = ({ videoExperiment }: WorthProps) => {
  const getTestAttributes = useTestFunc();
  const { recordEventAndNavigate } = useAnalyticEvent();
  const isMobile = useMediaQuery(`(max-width: ${breakpoint.sm})`);
  const isMd = useMediaQuery(`(min-width: ${breakpoint.md})`);
  const learnMoreUrl = buildNavigationUrl({ baseUrl: `/value-tracker` });
  const trackValueUrl = buildNavigationUrl({ baseUrl: `/value-tracker/get-value/vehicle` });

  const handleLearnMoreClick = (event: React.MouseEvent<HTMLElement>) =>
    recordEventAndNavigate(event, 'Landing Page', 'CVT - Learn more');

  const handleTrackValueClick = (event: React.MouseEvent<HTMLElement>) =>
    recordEventAndNavigate(event, 'Landing Page', 'CVT - Track my value');

  return (
    <Background className={videoExperiment ? 'boxshadow' : ''}>
      <Container className={videoExperiment ? 'boxshadow' : ''}>
        <ImgWrapper>
          <StyledImage
            alt="Car with tracking lines"
            src="/images/value-tracker"
            priority
            quality={100}
            width={0}
            height={0}
            loader={customLoader}
          />
          <StyledImage
            alt="Car with tracking lines"
            src="/images/value-tracker-mobile"
            priority
            quality={100}
            width={0}
            height={0}
            loader={customLoader}
            className="mobile"
          />
        </ImgWrapper>
        <TextContainer>
          <LogoWrapper>
            <ValueTrackerLogo size={isMd ? 'large' : 'small'} />
          </LogoWrapper>
          <HeadLine>Stay up to speed with your car’s value</HeadLine>
          <Text>
            Not ready to sell yet? Get updates so you always know your car’s value.{' '}
            <StyledLink
              size={isMobile ? 'md' : 'lg'}
              href={learnMoreUrl}
              onClick={handleLearnMoreClick}
              {...getTestAttributes('LearnMore', 'ValueTracker-LearnMore')}
            >
              Learn more
            </StyledLink>
          </Text>
          <RedirectLink href={trackValueUrl} className="tablet" onClick={handleTrackValueClick}>
            <Button size="sm" variant="secondary" {...getTestAttributes('TrackMyValue')}>
              Track my value
            </Button>
          </RedirectLink>
        </TextContainer>
        <RedirectLink href={trackValueUrl} onClick={handleTrackValueClick}>
          <Button size="lg" variant="secondary" {...getTestAttributes('TrackMyValue')}>
            Track my value
          </Button>
        </RedirectLink>
      </Container>
    </Background>
  );
};

export default Worth;
